export default {
  name: 'restoration',
  path: '~/restoration?token',
  i18n: ['auth/restoration', 'app'],
  loadComponent: () => import('./index')
};
